import React from 'react';
import Login2 from './auth/login/login-2';

const AuthFeature: React.FC = () => {
    return <Login2 />;
};

export default AuthFeature;
